<template>
  <Tabs
    v-if="discount"
    :tab-name="['Detail']"
    :tab-icon="['event_available']"
    class="page-subcategories"
    nav-pills-icons
    color-button="primary"
  >
    <template slot="tab-pane-1">
      <discountEdit
        :discount="discount"
        @discountUpdated="$emit('discountUpdated', $event)"
      />
    </template>
  </Tabs>
</template>

<script>
import { Tabs } from "@/components";
import DiscountEdit from "./DiscountEdit";

export default {
  props: ["discount"],

  components: {
    Tabs,
    DiscountEdit
  },

  data() {
    return {};
  }
};
</script>
